module.exports = __webpack_public_path__ + "img/1.793c2b68.png";